export default __webpack_public_path__ + "static/media/wt-green-copy.0596f6d7.svg";